// @flow
import { CLARK_PRIMARY, CLARK_TERTIARY, BACKGROUND_COLOR_SUCCESS } from 'styles/colors';

const GENERIC_MESSAGE = 'If this issue persists please contact help@hiclark.com.';

const FLASH_BANNERS = {
  POST_PAYER_CHARGE_CONFIRMATION_FAILURE: () => ({
    color: `${CLARK_PRIMARY}`,
    title: 'Error processing payment',
  }),
  POST_PAYER_PAYMENT_METHOD_FAILURE: () => ({
    color: `${CLARK_PRIMARY}`,
    title: 'Error processing payment',
  }),
  POST_TUTOR_RESET_PASSWORD_EMAIL_SUCCESS: () => ({
    color: `${BACKGROUND_COLOR_SUCCESS}`,
    buttonColor: `${CLARK_TERTIARY}`,
    title: "We've sent you an email. Click the link to reset your password",
    message: 'Contact use at clark@hiclark.com if you run into problems',
  }),
  POST_TUTOR_PASSWORD_SUCCESS: () => ({
    color: `${BACKGROUND_COLOR_SUCCESS}`,
    buttonColor: `${CLARK_TERTIARY}`,
    title: 'Your password has been reset!',
  }),
  POST_TUTOR_PASSWORD_FAILURE: () => ({
    color: `${CLARK_PRIMARY}`,
    title: 'Password reset failed.',
    message: `${GENERIC_MESSAGE}`,
  }),
  PUT_SESSION_CANCEL_SUCCESS: () => ({
    color: `${BACKGROUND_COLOR_SUCCESS}`,
    buttonColor: `${CLARK_TERTIARY}`,
    title: 'Session canceled!',
  }),
  PUT_SESSION_DELETE_SUCCESS: () => ({
    color: `${BACKGROUND_COLOR_SUCCESS}`,
    buttonColor: `${CLARK_TERTIARY}`,
    title: `Session has been deleted.`,
  }),
  '200': () => ({
    color: `${BACKGROUND_COLOR_SUCCESS}`,
    buttonColor: `${CLARK_TERTIARY}`,
    title: `Success!`,
  }),
  '400': () => ({
    color: `${CLARK_PRIMARY}`,
    title: 'Bad Request',
    message: `${GENERIC_MESSAGE}`,
  }),
  '401': () => ({
    color: `${CLARK_PRIMARY}`,
    title: 'Sorry! Your account could not be authorized.',
    message: `${GENERIC_MESSAGE}`,
  }),
  '404': () => ({
    color: `${CLARK_PRIMARY}`,
    title: 'Sorry! The page you were looking for could not be found.',
    message: `${GENERIC_MESSAGE}`,
  }),
  '409': () => ({
    color: `${CLARK_PRIMARY}`,
    title: "Looks like you already have one of those, and we can't create another.",
    message: `${GENERIC_MESSAGE}`,
  }),
  '500': () => ({
    color: `${CLARK_PRIMARY}`,
    title: `Sorry! We are experiencing server issues.`,
    message: `${GENERIC_MESSAGE}`,
  }),
};

export default FLASH_BANNERS;



// WEBPACK FOOTER //
// ./src/containers/flash-banner/data.js